import { moneyCents } from './salesCommissionForm';

const message = (t, key) => t(`SALES.COMMISSION.ERRORS.${key}`);

const companyErrors = (form, t) => {
  const errors = {};
  const gross = moneyCents(form.gross_amount);
  const deduction = moneyCents(form.deduction);
  if (!gross) errors.gross_amount = message(t, 'GROSS_REQUIRED');
  if (deduction >= gross) errors.deduction = message(t, 'DEDUCTION');
  if (!form.payment_method)
    errors.payment_method = message(t, 'PAYMENT_METHOD');
  return errors;
};

const installmentErrors = (form, t) => {
  const rows = Array.isArray(form.installments) ? form.installments : [];
  const errors = { rows: [] };
  if (!rows.length)
    return { form: message(t, 'INSTALLMENTS_REQUIRED'), rows: [] };

  const periodCounts = rows.reduce((counts, row) => {
    if (row.payment_trigger)
      counts[row.payment_trigger] = (counts[row.payment_trigger] || 0) + 1;
    return counts;
  }, {});
  rows.forEach((row, index) => {
    const rowErrors = {};
    if (!moneyCents(row.amount))
      rowErrors.amount = message(t, 'AMOUNT_REQUIRED');
    if (!row.payment_trigger)
      rowErrors.payment_trigger = message(t, 'PERIOD_REQUIRED');
    else if (periodCounts[row.payment_trigger] > 1)
      rowErrors.payment_trigger = message(t, 'PERIOD_DUPLICATE');
    const payerTotal = (row.payers || []).reduce(
      (total, payer) => total + moneyCents(payer.amount),
      0
    );
    if (row.payers?.length && payerTotal !== moneyCents(row.amount)) {
      rowErrors.payers = message(t, 'PAYERS_TOTAL');
    }
    errors.rows[index] = rowErrors;
  });

  const total = rows.reduce((sum, row) => sum + moneyCents(row.amount), 0);
  if (total !== moneyCents(form.net_amount))
    errors.form = message(t, 'INSTALLMENTS_TOTAL');
  return errors;
};

const participantErrors = (form, group, t) => {
  const value = form.participants?.[group] || {};
  const rows = value.rows || [];
  const errors = { rows: [] };
  if (value.enabled === false) return errors;
  if (!rows.length) return errors;

  const totalPercentage = Number(value.total_percentage || 0);
  if (totalPercentage <= 0 || totalPercentage > 100)
    errors.total_percentage = message(t, 'GROUP_PERCENTAGE');
  const individualTotal = rows.reduce(
    (total, row) => total + Number(row.percentage || 0),
    0
  );
  if (Math.round(individualTotal * 100) !== 10000)
    errors.form = message(t, 'PARTICIPANTS_TOTAL');

  rows.forEach((row, index) => {
    const rowErrors = {};
    if (!row.name) rowErrors.name = message(t, 'NAME_REQUIRED');
    if (Number(row.percentage || 0) <= 0)
      rowErrors.percentage = message(t, 'PERCENTAGE_REQUIRED');
    if (row.person_type === 'PJ' && !row.cnpj)
      rowErrors.document = message(t, 'CNPJ_REQUIRED');
    if (row.person_type !== 'PJ' && !row.cpf)
      rowErrors.document = message(t, 'CPF_REQUIRED');
    if (
      row.payment_type === 'banco' &&
      (!row.bank_id || !row.branch || !row.account_number)
    ) {
      rowErrors.payment = message(t, 'BANK_REQUIRED');
    }
    if (row.payment_type === 'pix' && (!row.pix_key_type || !row.pix_key)) {
      rowErrors.payment = message(t, 'PIX_REQUIRED');
    }
    errors.rows[index] = rowErrors;
  });
  return errors;
};

export const salesCommissionSectionErrors = ({ form, section, t }) => {
  if (section === 'company') return companyErrors(form, t);
  if (section === 'installments') return installmentErrors(form, t);
  return participantErrors(form, section, t);
};

export const hasCommissionErrors = errors => {
  if (!errors) return false;
  if (Object.keys(errors).some(key => key !== 'rows')) return true;
  return (errors.rows || []).some(row => Object.keys(row || {}).length > 0);
};
